"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchOffers = exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _main = _interopRequireDefault(require("../main"));
var _spinner = _interopRequireDefault(require("../loading/spinner"));
var _getOffers = _interopRequireDefault(require("./getOffers"));
var _changeOffer = _interopRequireDefault(require("./changeOffer"));
var _excluded = ["originalOffer"],
  _excluded2 = ["originalOffer"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } } // eslint-disable-line no-unused-vars
var fetchOffers = function fetchOffers(opts) {
  return (0, _getOffers.default)(opts);
};
exports.fetchOffers = fetchOffers;
var Educator = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Educator, _Component);
  var _super = _createSuper(Educator);
  function Educator() {
    var _this;
    (0, _classCallCheck2.default)(this, Educator);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      application: null,
      offers: [],
      isSubmitting: false
    });
    return _this;
  }
  (0, _createClass2.default)(Educator, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var _this$props = this.props,
        id = _this$props.id,
        fetchOfferUrl = _this$props.fetchOfferUrl,
        changeAmount = _this$props.amount;
      return fetchOffers({
        fetchOfferUrl: fetchOfferUrl,
        query: {
          id: id,
          changeAmount: changeAmount
        }
      }).then(function (data) {
        var application = data.originalOffer,
          rest = (0, _objectWithoutProperties2.default)(data, _excluded);
        _this2.setState(_objectSpread({
          application: application
        }, rest));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$state = this.state,
        application = _this$state.application,
        offers = _this$state.offers,
        isSubmitting = _this$state.isSubmitting;
      var _this$props2 = this.props,
        id = _this$props2.id,
        fetchOfferUrl = _this$props2.fetchOfferUrl,
        onRevisionChange = _this$props2.onRevisionChange,
        onRevisionError = _this$props2.onRevisionError,
        constants = _this$props2.constants,
        disclosureContent = _this$props2.disclosureContent,
        subMarket = _this$props2.subMarket;
      var actions = {
        fetchOffers: function fetchOffers(params) {
          var query = _objectSpread({
            id: id
          }, params);
          (0, _getOffers.default)({
            fetchOfferUrl: fetchOfferUrl,
            query: query
          }).then(function (data) {
            var application = data.originalOffer,
              rest = (0, _objectWithoutProperties2.default)(data, _excluded2);
            _this3.setState(_objectSpread({
              application: application
            }, rest));
          });
        },
        submitRevisions: function submitRevisions(opts) {
          var _this3$state = _this3.state,
            amount = _this3$state.application.amount,
            application = _this3$state.application;
          var _opts$params = opts.params,
            offerId = _opts$params.planId,
            productType = _opts$params.productType,
            _opts$params$amount = _opts$params.amount,
            changeAmount = _opts$params$amount === void 0 ? amount : _opts$params$amount;
          _this3.setState({
            isSubmitting: true
          });
          var body = {
            id: +id,
            offerId: +offerId,
            productType: productType,
            changeAmount: changeAmount
          };
          (0, _changeOffer.default)({
            fetchOfferUrl: fetchOfferUrl,
            body: body
          }).then(function () {
            if (typeof onRevisionChange === 'function') {
              var newOffer = offers.find(function (_ref) {
                var id = _ref.id;
                return +id === +offerId;
              });
              application.rate = newOffer.intRate;
              application.term = newOffer.term;
              application.isInterestFree = newOffer.product === 'INTEREST_FREE_LOAN';
              application.amount = changeAmount;
              onRevisionChange(application, id);
              _this3.setState({
                isSubmitting: false
              });
            }
          }).catch(function () {
            if (typeof onRevisionError === 'function') {
              _this3.setState({
                isSubmitting: false
              });
              onRevisionError();
            }
          });
        }
      };
      return application && offers.length && !isSubmitting ? /*#__PURE__*/_react.default.createElement("div", {
        className: "revisions-educator"
      }, /*#__PURE__*/_react.default.createElement(_main.default, {
        constants: constants,
        disclosureContent: disclosureContent,
        application: application,
        organization: "Your Tuition Solution",
        actions: actions,
        offers: offers,
        subMarket: subMarket
      })) : /*#__PURE__*/_react.default.createElement(_spinner.default, Object.assign({
        className: "revisions"
      }, this.props));
    }
  }]);
  return Educator;
}(_react.Component);
(0, _defineProperty2.default)(Educator, "propTypes", {
  fetchOfferUrl: _propTypes.default.string,
  amount: _propTypes.default.string,
  id: _propTypes.default.string,
  onRevisionChange: _propTypes.default.func,
  onRevisionError: _propTypes.default.func,
  constants: _propTypes.default.object,
  disclosureContent: _propTypes.default.object,
  subMarket: _propTypes.default.string
});
var _default = Educator;
exports.default = _default;
require('/var/lib/jenkins/workspace/pf-yts-ui_Release_0/node_modules/pf-revisions-v2/dist/pf-revisions.scss');